import React from 'react';
import { motion } from 'framer-motion';
export function TerminalDivider({
  command
}: {
  command: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} className="max-w-md mx-auto my-10 bg-petroleum/60 backdrop-blur border border-electric/20 rounded-lg overflow-hidden shadow-lg relative z-10" data-id="element-645">
      <div className="bg-graphite/80 px-3 py-2 flex items-center gap-2 border-b border-electric/10 relative" data-id="element-646">
        <div className="flex gap-1.5" data-id="element-647">
          <div className="w-2.5 h-2.5 rounded-full bg-danger" data-id="element-648"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-electric" data-id="element-649"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-energy" data-id="element-650"></div>
        </div>
        <div className="absolute left-1/2 -translate-x-1/2 text-[10px] text-textsecondary font-mono opacity-50" data-id="element-651">
          freelancer.sh
        </div>
      </div>
      <div className="px-4 py-3 font-mono text-sm" data-id="element-652">
        <div className="flex items-center gap-2" data-id="element-653">
          <span className="text-energy font-bold" data-id="element-654">$</span>
          <span className="text-white" data-id="element-655">{command}</span>
        </div>
        <div className="flex items-center gap-2 mt-1.5" data-id="element-656">
          <span className="text-textsecondary/60" data-id="element-657">{'>'} done.</span>
          <span className="w-2 h-4 bg-textsecondary/60 animate-[pulse_1s_steps(2,start)_infinite]" data-id="element-658"></span>
        </div>
      </div>
    </motion.div>;
}